export default {
  isDevelopment: !process.env.NODE_ENV || process.env.NODE_ENV === 'development',
  apiUrl: process.env.REACT_APP_HOST_BACKEND || 'http://localhost:3000',
  stripeApi: process.env.REACT_APP_STRIPE_API || 'https://api.stripe.com',
  stripeApiKey: process.env.REACT_APP_STRIPE_API_KEY || '',
  organizationId: process.env.REACT_APP_ORGANIZATION_ID || '', // should be empty on production
  googleAPIKey: process.env.REACT_APP_GOOGLE_API_KEY || '',
  rootPath: process.env.REACT_APP_ROOT_PATH || '/portal',
  googleMapsUrl: 'https://maps.google.com',
  oldPortalUrl: process.env.REACT_OLD_PORTAL_URL || 'https://dev2.adracare.com',
  countryCode: (process.env.REACT_APP_COUNTRY || 'ca').toUpperCase(),
  useReactVideoSessions: process.env.REACT_APP_USE_REACT_VIDEO_SESSION === 'true' || false,
  recaptchaSiteKey: process.env.REACT_APP_RECAPTCHA_SITE_KEY || '',
  whiteboardUrl: process.env.REACT_APP_WHITEBOARD_URL || '',
  intercom: {
    // put routes for pages intercom needs to be hidden.  e.g. 'online-intake', 'direct.appointments', 'video-session'
    appId: process.env.REACT_APP_INTERCOM_APP_ID,
    hideAll: process.env.REACT_APP_HIDE_INTERCOM,
    hideRoutes: [],
  },
};
